import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { translations, CATEGORY_LABELS } from "@/i18n/translations";
import { api } from "@/lib/api";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("dtm-lang") || "en");
  const [overrides, setOverrides] = useState({});

  useEffect(() => {
    api
      .get("/site-content")
      .then((r) => setOverrides(r.data || {}))
      .catch(() => {});
  }, []);

  const setLang = useCallback((l) => {
    localStorage.setItem("dtm-lang", l);
    setLangState(l);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key) => overrides[key]?.[lang] || translations[lang]?.[key] || translations.en[key] || key,
    [lang, overrides]
  );
  const tCat = useCallback(
    (cat) => (lang === "fr" ? CATEGORY_LABELS.fr[cat] ?? cat : cat),
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tCat }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
